import { Subscription, SubscriptionPackage } from "./types";

export const initialSubscription: Subscription = {
  id: '',
  created: null,
  subscriptionPackage: null,
};


export const initialSubscriptionPackage: SubscriptionPackage = {
  id: '',
  name: null,
  description: null,
  price: null,
};
